import { z } from "zod";
import { MAX_DAILY_REPORT_HOURS } from "./dailyReportHoursValue";

// Informational read contract: compatible with historical integers and numeric half-hours.
export const dailyReportHoursSchema = z.number()
  .min(0)
  .max(MAX_DAILY_REPORT_HOURS)
  .multipleOf(0.5);

// The product contract authorizes half-hour writes; do not infer tenths from numeric scale.
export const dailyReportHoursWriteSchema = z.number()
  .min(0)
  .max(MAX_DAILY_REPORT_HOURS)
  .multipleOf(0.5);

export { formatDailyReportHours, MAX_DAILY_REPORT_HOURS } from "./dailyReportHoursValue";
